/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
import { Remediator } from './Remediator';
// Base class - DO NOT expose static remediationName
export class AuthenticatorData extends Remediator {
    constructor(remediation, values = {}) {
        var _a;
        super(remediation, values);
        this.map = {
            'authenticator': []
        };
        // Unify authenticator input type
        const { authenticators } = this.values;
        const authenticatorKey = this.getAuthenticator().key;
        const authenticator = (_a = authenticators) === null || _a === void 0 ? void 0 : _a.find(authenticator => authenticator.key === authenticatorKey);
        if (authenticator) {
            // map
            this.values.authenticators = authenticators.map(authenticator => {
                if (authenticatorKey === authenticator.type) {
                    return this.mapAuthenticatorFromValues(authenticator);
                }
                return authenticator;
            });
        }
        else {
            // add
            this.values.authenticators = [
                ...authenticators,
                this.mapAuthenticatorFromValues()
            ];
        }
    }
    getNextStep() {
        const common = super.getNextStep();
        const options = this.getMethodTypes();
        return Object.assign(Object.assign({}, common), (options && { options }));
    }
    // Grab authenticator from authenticators list
    getAuthenticatorFromValues() {
        if (!this.values.authenticators) {
            return null;
        }
        const authenticatorKey = this.getAuthenticator().key;
        const authenticator = this.values.authenticators
            .find(authenticator => authenticator.key === authenticatorKey);
        return authenticator;
    }
    mapAuthenticatorFromValues(authenticator) {
        // add methodType to authenticator if it exists in values
        const key = this.getAuthenticator().key;
        const { methodType } = this.values;
        return Object.assign(Object.assign({ key }, (authenticator && authenticator)), (methodType && { methodType }));
    }
    getAuthenticatorFromRemediation() {
        const authenticator = this.remediation.value
            .find(({ name }) => name === 'authenticator');
        return authenticator;
    }
    getMethodTypes() {
        var _a;
        const authenticator = this.getAuthenticatorFromRemediation();
        return (_a = authenticator.form.value.find(({ name }) => name === 'methodType')) === null || _a === void 0 ? void 0 : _a.options;
    }
}
